import { cn } from '@/utils'
import { DateInput } from './inputs'
import type { FieldsetProps } from './types'

export function DateFieldset({
  operator,
  value,
  setValue,
  value2,
  setValue2,
}: FieldsetProps) {
  return (
    <div className={cn('grid gap-2', operator === 'between' && 'grid-cols-2')}>
      <div className="grid gap-2">
        <DateInput label="Value" value={value} onChange={setValue} />
      </div>

      {operator === 'between' && (
        <div className="grid gap-2">
          <DateInput label="Second Value" value={value2} onChange={setValue2} />
        </div>
      )}
    </div>
  )
}
